// Central church configuration. Edit here to update the site content.
export const church = {
  name: "New Philadelphia Missionary Baptist Church",
  shortName: "New Philadelphia",
  slogan: "Where Tradition Meets Transformation",
  welcomeHeadline: "Welcome Home",
  welcomeSubheadline:
    "Where Faith Grows, Families Belong, and Lives Are Changed Through Jesus Christ.",
  logo:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_strange-cartwright-8/artifacts/x98i5ia3_F6D2C7CF-68BD-432C-8254-2E213B8DFD4C.png",

  address: {
    line1: "533 S. Mendenhall Rd.",
    city: "Memphis",
    state: "TN",
    zip: "38117",
  },
  phone: "(901) 685-8877",
  phoneRaw: "+19016858877",
  email: "info@newphiladelphiabaptist.org",

  services: [
    { name: "Sunday School", day: "Sunday", time: "10:00 AM" },
    { name: "Morning Worship", day: "Sunday", time: "11:00 AM" },
    { name: "Bible Study", day: "Wednesday", time: "6:00 PM", note: "Online via Zoom", zoom: "https://us06web.zoom.us/j/81438613450?pwd=WK66kMyAfPtX6VNNnjr2cFp3yQnpvS.1" },
  ],

  social: {
    facebook: "https://www.facebook.com/share/1E1vZqSHa7/?mibextid=wwXIfr",
    instagram: "https://instagram.com/",
    youtube: "https://youtube.com/",
    facebookLive: "https://www.facebook.com/share/1E1vZqSHa7/?mibextid=wwXIfr",
  },

  giving: {
    cashapp: "$NPMBCMendenhall",
    cashappUrl: "https://cash.app/$NPMBCMendenhall",
  },

  pastor: {
    name: "Pastor Darren M. Little",
    title: "Senior Pastor",
    bio:
      "Pastor Darren M. Little is the Senior Pastor of New Philadelphia Missionary Baptist Church, dedicated to preaching God's Word and leading others to a deeper relationship with Jesus Christ. He studied at the Memphis Center for Urban Theology and Memphis Theological Seminary in Memphis, Tennessee, and is passionate about serving the church and the community with faith, love, and biblical truth.",
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_strange-cartwright-8/artifacts/t7o4tn8r_df5a06af-8621-4f24-ab4c-d964be1620a4.png",
  },
};

export const fullAddress = `${church.address.line1}, ${church.address.city}, ${church.address.state} ${church.address.zip}`;

export const nav = [
  { label: "Home", to: "/" },
  {
    label: "About",
    to: "/about",
    children: [
      { label: "About Us", to: "/about" },
      { label: "Our Legacy", to: "/legacy" },
      { label: "Our Future", to: "/future" },
      { label: "Leadership", to: "/leadership" },
    ],
  },
  { label: "Ministries", to: "/ministries" },
  { label: "Events", to: "/events" },
  { label: "Gallery", to: "/gallery" },
  { label: "Media", to: "/media" },
  { label: "Give", to: "/give" },
  { label: "Visit", to: "/visit" },
  { label: "Contact", to: "/contact" },
];
